import { SxProps } from '@mui/material';

export const reviewText: SxProps = {
	color: 'text.primary',
};

export const readMoreButton: SxProps = {
	color: 'text.primary',
	padding: 0,
	display: 'contents',
	textTransform: 'none',
	fontSize: 'inherit',
	fontFamily: 'inherit',
	fontWeight: 'inherit',
};

export const starBox: SxProps = {
	display: 'flex',
	marginBottom: '0.5rem',
};

export const sourceContainer: SxProps = {
	marginTop: '0.5rem',
	display: 'flex',
	flexDirection: 'column',
};
